var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
var CardMetrics = function (props) {
    var _a = __read(useState(null), 2), valuesForNav = _a[0], setValuesForNav = _a[1];
    var label = props.label, value = props.value;
    useEffect(function () {
        var _a, _b;
        if (label.includes("NAV")) {
            var _c = __read(value.split(" "), 2), navValue = _c[0], changeChangePerInNav = _c[1];
            setValuesForNav({
                navValue: navValue,
                changeChangePerInNav: changeChangePerInNav,
                plusMinus: ((_b = (_a = changeChangePerInNav === null || changeChangePerInNav === void 0 ? void 0 : changeChangePerInNav.split("(")) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.includes("-"))
                    ? "-"
                    : "+",
            });
        }
    }, [label]);
    return (React.createElement("div", { className: "metric-item d-flex flex-column" },
        React.createElement("span", { className: "metric-label txt_manatee2 DMsanL_12_300" }, label),
        React.createElement("div", { className: "metric-value-container d-flex align-items-center Roboto_13_400 ".concat(valuesForNav ? "flex-column" : "") },
            !label.includes("NAV") && (React.createElement("span", { className: "metric-value align-self-start" }, value)),
            label.includes("NAV") && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "metric-value align-self-start" }, Number(valuesForNav === null || valuesForNav === void 0 ? void 0 : valuesForNav.navValue).toFixed(2)),
                !(props === null || props === void 0 ? void 0 : props.isFundSelectedForSwitchTransfer) && (React.createElement("div", { className: "d-flex ".concat((valuesForNav === null || valuesForNav === void 0 ? void 0 : valuesForNav.plusMinus) === "-"
                        ? "txt-tomato"
                        : "txt_nuvama-green") },
                    (valuesForNav === null || valuesForNav === void 0 ? void 0 : valuesForNav.plusMinus) === "-" ? "" : "+", valuesForNav === null || valuesForNav === void 0 ? void 0 :
                    valuesForNav.changeChangePerInNav)))))));
};
export default CardMetrics;
